import { calculateDeviation, calculateGrowth } from "./calculations"

export function rearrangeAndEnrichRevenueTargetData({
  currentYearRevenue,
  lastYearRevenue,
  yearBeforeLastYearRevenue,
}) {
  const transformedArray = transformData(currentYearRevenue, lastYearRevenue, yearBeforeLastYearRevenue)
  return addDeviationFromTargetData(transformedArray)
}

export function calculateSummary(statsByArticleMainGroup) {
  const currentYearRevenue = statsByArticleMainGroup.reduce((acc, item) => {
    const revenue = Number(item.currentYearRevenue)
    return acc + (isNaN(revenue) ? 0 : revenue)
  }, 0)

  const currentYearRevenueTarget = statsByArticleMainGroup.reduce((acc, item) => {
    const revenue = Number(item.currentYearRevenueTarget)
    return acc + (isNaN(revenue) ? 0 : revenue)
  }, 0)

  const lastYearRevenue = statsByArticleMainGroup.reduce((acc, item) => {
    const revenue = Number(item.lastYearRevenue)
    return acc + (isNaN(revenue) ? 0 : revenue)
  }, 0)

  const yearBeforeLastYearRevenue = statsByArticleMainGroup.reduce((acc, item) => {
    const revenue = Number(item.yearBeforeLastYearRevenue)
    return acc + (isNaN(revenue) ? 0 : revenue)
  }, 0)

  const revenueDeviationFromTarget = calculateDeviation(currentYearRevenue, currentYearRevenueTarget)

  const revenueDeviationFromTargetInPercent = calculateGrowth(currentYearRevenue, currentYearRevenueTarget)

  return {
    currentYearRevenue,
    currentYearRevenueTarget,
    lastYearRevenue,
    revenueDeviationFromTarget,
    revenueDeviationFromTargetInPercent,
    yearBeforeLastYearRevenue,
  }
}

function addDeviationFromTargetData(transformedArray) {
  return transformedArray.map((item) => {
    const revenueDeviationFromTarget = calculateDeviation(
      Number(item?.currentYearRevenue),
      Number(item?.currentYearRevenueTarget),
    )

    const revenueDeviationFromTargetInPercent = calculateGrowth(
      Number(item?.currentYearRevenue),
      Number(item?.currentYearRevenueTarget),
    )
    return {
      ...item,
      revenueDeviationFromTarget,
      revenueDeviationFromTargetInPercent,
    }
  })
}

function transformData(currentYearRevenue, lastYearRevenue, yearBeforeLastYearRevenue) {
  const transformedData = {}

  currentYearRevenue?.forEach(({ articleMainGroup, revenue, revenueTarget }) => {
    transformedData[articleMainGroup] = {
      articleMainGroup,
      currentYearRevenue: revenue,
      currentYearRevenueTarget: revenueTarget,
    }
  })

  lastYearRevenue?.forEach(({ articleMainGroup, revenue }) => {
    if (transformedData[articleMainGroup]) {
      transformedData[articleMainGroup].lastYearRevenue = revenue
    } else {
      transformedData[articleMainGroup] = {
        articleMainGroup,
        lastYearRevenue: revenue,
      }
    }
  })

  yearBeforeLastYearRevenue?.forEach(({ articleMainGroup, revenue }) => {
    if (transformedData[articleMainGroup]) {
      transformedData[articleMainGroup].yearBeforeLastYearRevenue = revenue
    } else {
      transformedData[articleMainGroup] = {
        articleMainGroup,
        yearBeforeLastYearRevenue: revenue,
      }
    }
  })

  return Object.values(transformedData)
}
